module.exports = __webpack_public_path__ + "static/media/yuemeishan_package.7fa8644c.png";